var __WEBPACK_NAMESPACE_OBJECT__ = mobxStateTree;